import React from 'react';
import EntityLinkButton from '../../../../shared/components/linked-entities/EntityLinkButton';
import { useLinkedEntityCards } from '../../../../shared/components/linked-entities/LinkedEntityCardHost';
import { entityLabel, selectedEntityIds } from '../../../../shared/utils/entitySelection';

const workspaceIds = (member) => [member.linkedWorkspaceUserId, member.workspaceUserId, member.userId].filter((id) => id != null && id !== '').map(String);
export function resolveAssignmentStaff(userId, staff = []) {
  if (userId == null || userId === '') return null;
  // Workspace user IDs and staff record IDs are separate namespaces.
  return staff.find((member) => workspaceIds(member).includes(String(userId)))
    || staff.find((member) => workspaceIds(member).length === 0 && String(member.id) === String(userId)) || null;
}

export default function AssignmentRelationLinks({ kind, assignment = {}, clients = [], suppliers = [], staff = [], currentUser = {} }) {
  const { openEntityCard } = useLinkedEntityCards();
  let entries = [];
  if (['client', 'supplier', 'parties'].includes(kind)) {
    entries = (kind === 'parties' ? ['client', 'supplier'] : [kind]).flatMap((type) => {
      const catalog = type === 'client' ? clients : suppliers;
      const fallback = assignment[`${type}Name`] || assignment[type] || '';
      const ids = selectedEntityIds(assignment, type);
      return ids.length ? ids.map((id, index) => ({ type, id, label: entityLabel(catalog.find((item) => String(item.id) === id)) || (index === 0 ? fallback : '') || `${type === 'client' ? 'Cliente' : 'Fornitore'} ${id}` })) : fallback ? [{ label: fallback }] : [];
    });
  } else {
    const ids = kind === 'sender' ? [assignment.senderId] : assignment.recipientIds || [];
    entries = ids.filter((id) => id != null && id !== '').map((id, index) => {
      const member = resolveAssignmentStaff(id, staff);
      const fallback = kind === 'sender' ? assignment.sender : assignment.recipients?.[index];
      const label = entityLabel(member || {}) || fallback || `Utente ${id}`;
      return { type: 'staff', id: member?.id, label: `${label}${String(id) === String(currentUser.id) ? ' (Tu)' : ''}` };
    });
    if (kind === 'recipients') {
      selectedEntityIds(assignment, 'staff').forEach((id) => {
        if (!entries.some((entry) => String(entry.id) === id)) entries.push({ type: 'staff', id, label: entityLabel(staff.find((member) => String(member.id) === id)) || `Membro ${id}` });
      });
    }
    if (!entries.length) entries = (kind === 'sender' ? [assignment.sender] : assignment.recipients || []).filter(Boolean).map((label) => ({ label }));
  }
  return <span className="assignment-relation-links">{entries.length ? entries.map((entry, index) => entry.id != null ? <EntityLinkButton key={`${entry.type}:${entry.id}:${index}`} onClick={() => openEntityCard({ entityType: entry.type, entityId: entry.id })}>{entry.label}</EntityLinkButton> : <span key={index}>{entry.label}</span>) : '—'}</span>;
}
